import { Divider } from "antd";
import moment from "moment";
import React from "react";

function NotificationPage({ props }) {
  const { data, onRead, onPage, loadPage, isMore } = props;

  return (
    <div className="notif">
      <div className="container mx-auto py-6 lg:py-10">
        {/* Ini Adalah Breadcrumb */}
        <div name="breadecrumb" className="flex items-center mb-6 lg:mb-8">
          <p className="m-0 text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-gray">
            Home
          </p>
          <img
            className="mr-3 lg:mr-5"
            src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_arrow.svg"}
            alt="icon-arrow"
          />
          <p className="m-0 text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-blue">
            List Notifikasi
          </p>
        </div>

        {/* Mulai Content  */}
        <div className="w-full flex justify-center">
          <div className="notif-wrapper w-full lg:w-3/5 ">
            <div className="p-2 lg:px-12 lg:pt-10">
              <div className="flex justify-center">
                {data.length === 0 && (
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "/assets/icon/ic_notif_promo.svg"
                    }
                    alt="icon-promo"
                    className="w-20 h-20"
                  />
                )}
              </div>
              <p className="header-title-bold text-xl lg:text-3xl colors-blue font-bold mb-3 text-center">
                {data.length > 0 ? "Semua Notifikasi" : "Tidak ada Notifikasi"}
              </p>
              <p className="text-center mb-6 lg:mb-6">
                Menampilkan semua notifikasi terkait pesanan yang anda lakukan
              </p>

              {/* Item Notifikasi */}
              {data.slice(0, 10).map((it, index) => (
                <div key={index} className="mb-6">
                  <div className="flex items-center">
                    <div className="flex items-start">
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/ic_promo_big.svg"
                        }
                        alt="icon-promo"
                        className="mr-5 cursor-pointer"
                      />
                      <div>
                        <p className="header-title text-xs">
                          {moment(it?.created_at ?? "00-00-0000").format(
                            "DD MMMM YYYY"
                          )}
                        </p>
                        <p className="header-title-bold text-xl">
                          {it?.title ?? ""}
                        </p>
                        <p className="header-title mt-1">{it?.body ?? ""}</p>
                      </div>
                    </div>
                  </div>
                  <Divider />
                </div>
              ))}

              {data.length > 0 && (
                <div>
                  {isMore && (
                    <button
                      disabled={loadPage}
                      onClick={onPage}
                      className="btn-blue w-full p-3  focus:outline-none"
                    >
                      <p className="text-white font-semibold lg:text-lg">
                        {loadPage ? "Loading" : "Lihat Selengkapnya"}
                      </p>
                    </button>
                  )}
                  <button
                    onClick={onRead}
                    className="btn-white-border  w-full p-3 my-5 focus:outline-none"
                  >
                    <div className="text-white-border font-semibold lg:text-lg">
                      <div className="colors-blue lg:text-lg">
                        Telah dibaca semua
                      </div>
                    </div>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotificationPage;
